// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PPropertySafetyOutlinedSvg from "@fishx/icons-svg/es/asn/PPropertySafetyOutlined";
import FishxIcon from '../components/FishxIcon';

var PPropertySafetyOutlined = function PPropertySafetyOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PPropertySafetyOutlinedSvg
  }));
};

PPropertySafetyOutlined.displayName = 'PPropertySafetyOutlined';
export default React.forwardRef(PPropertySafetyOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PPropertySafetyOutlined.js
// module id = 3551
// module chunks = 0